<!-- Copyright 2022, Common Good Learning Tools LLC -->
<template><div class="k-collections-unit-content-wrapper" :class="collection.units.length==1?'k-collections-unit-content-wrapper-single-unit':''">
	<div class="ma-2">
		<div class="d-flex">
			<h3 v-show="unit.title" class="ml-1" style="font-weight:normal; line-height:1.3em;">
				<k-icon class="mr-2" :style="folder_icon_css" style="font-size:20px;margin-top:-3px">fas fa-forward</k-icon>
				<b v-if="unit.display_number" class="mr-2" v-html="unit.display_number"></b>
				<span v-html="title_for_header"></span>
				<span v-if="unit.duration > 0" class="ml-2" style="font-size: 0.8em; color: #666; font-weight: bold">{{collection.effective_duration(unit, term_mode)}} WEEK{{unit.duration != 1 ? 'S' : ''}}</span>
			</h3>
			<k-spacer/>
			<div style="width:220px" class="k-instance-unit-autocomplete" v-if="show_instance_selector"><k-autocomplete ref="instance_selector" dense outlined class="ml-4"
                :items="instance_selector_options" item-text="title" v-model="instance_selector_value" label="Show content for…"
                @change="select_instance_unit" return-object>
				<template v-slot:item="{ item }"><span style="font-size:14px">
					<span v-if="item.is_flex_unit"><b>Template Content:</b> {{item.title}}</span>
					<span v-else>{{item.title}}</span>
				</span></template>
            </k-autocomplete></div>
			<!-- <div v-if="viewing_users_shadow_unit&&site_config.enable_sandbox_simulate_role_menu=='yes'"> -->
			<div v-if="false">
				<k-spacer/>
				<!-- we may not end up supporting this: for districts we have the coteacher role which is similar; for states people can just make my collections -->
				<k-menu bottom left><template v-slot:activator="{on}"><k-btn v-on="on" small  class="k-edit-btn xk-tight-btn xk-nocaps-btn" color="#555" dark @click=""><k-icon class="mr-1" small>fas fa-user</k-icon>View Content For…</k-btn></template>
					<k-list dense min-width="250">
						<k-list-item @click="share_my_content"><k-list-item-icon><k-icon small>fas fa-share-nodes</k-icon></k-list-item-icon><k-list-item-title>Share My Content for this collection with another user…</k-list-item-title></k-list-item>
						<k-list-item @click="subscribe_to_my_content"><k-list-item-icon><k-icon small>fas fa-cubes-stacked</k-icon></k-list-item-icon><k-list-item-title>Subscribe to another user’s My Content for this collection…</k-list-item-title></k-list-item>
						<!-- <k-divider/> -->
					</k-list>
				</k-menu>
			</div>
		</div>

		<div v-if="unit_text" class="k-collection-unit-description-outer" v-visible="unit_description_style!='visibility:hidden'">
			<div v-if="!unit_descriptions_collapsed_computed" class="k-collection-unit-description fr-view px-3 pt-2 pb-0 white" :style="(unit_descriptions_collapsible||unit_show_full_description_btn)?'border-radius:10px 10px 0 0;border-bottom:1px solid #ccc;':'border-radius:10px;'">
				<div class="k-collection-unit-description-inner pb-2" :style="unit_description_style" v-html="unit_text"></div>
				<div style="clear:both;padding-bottom:1px;"></div><!-- this prevents annoying extra margin at the bottom of the description div -->
			</div>
			<div v-if="unit_descriptions_collapsible||unit_show_full_description_btn" class="d-flex" style="cursor:pointer;border-radius:0 0 8px 8px;" :style="unit_descriptions_collapsed_computed?'':'border-top:1px solid #ccc'">
				<k-btn v-if="!unit_descriptions_collapsed_computed&&unit_show_full_description_btn" small text color="secondary" style="border-radius:0 0 0 8px" @click="unit.full_description_showing=!unit.full_description_showing">Show {{unit.full_description_showing?'Less':'More'}}<k-icon small class="ml-2">fas fa-caret-{{unit.full_description_showing?'up':'down'}}</k-icon></k-btn>
				<k-spacer/>
				<k-btn v-if="unit_descriptions_collapsible && !unit_descriptions_collapsed_computed" small text color="secondary" class="k-tight-btn" style="border-radius:0 0 8px 0" @click="toggle_unit_descriptions_collapsed">Collapse Unit Descriptions<k-icon small class="ml-2">fas fa-xmark</k-icon></k-btn>
				<k-btn v-if="unit_descriptions_collapsible && unit_descriptions_collapsed_computed" small text color="secondary" class="k-tight-btn" style="border-radius:0 0 8px 0" @click="toggle_unit_descriptions_collapsed">Show Unit Descriptions<k-icon small class="ml-2">fas fa-caret-down</k-icon></k-btn>
			</div>
		</div>
	</div>

	<div v-if="!initialized" class="ma-3"><b>LOADING UNIT CONTENTS…</b></div>
	<div v-else>
		<div class="d-flex mt-4" v-if="show_unit_mode_toggle">
			<k-spacer/>
			<k-btn-toggle class="k-course-view-toggle-btn elevation-3" active-class="k-course-view-unit-toggle-btn-active-class" v-model="unit_mode" mandatory>
				<k-btn v-for="(mode) in unit_mode_btn_order" :key="mode" small class="k-tight-btn k-nocaps-btn" 
					v-if="unit_mode_btn_data[mode].show" 
					:style="unit_mode_btn_data[mode].style"
					:value="mode" 
					@click="unit_mode_changed(mode)">
						<k-icon small class="mr-1" :color="(unit_mode == mode) ? '#fff' : '#888'">{{unit_mode_btn_data[mode].icon}}</k-icon>
						{{ unit_mode_btn_data[mode].button_text}}
				</k-btn>
			</k-btn-toggle>
			<k-spacer/>
		</div>

		<div v-if="unit_mode == 'resources' || unit_mode == 'my_content' || (!show_assignments && unit.standards.length == 0)">
			<div style="display:flex" class="justify-center mx-2">
				<div style="flex:1 1 100%">
					<div class="d-flex align-center mt-3 mr-1 mb-2" v-if="unit_has_resources">
						<div v-if="site_config.hide_unit_view_header!='yes'" class="k-unit-view-header" v-html="resources_header_text"></div>
						<div v-if="show_sort_by_control" class="d-flex align-center" style="margin-top:-6px">
							<div style="font-size:16px; margin-top:2px;" class="mr-2">Sort by:</div>
							<k-tooltip bottom><template v-slot:activator="{on}"><div v-on="on">
								<k-btn-toggle dense active-class="k-toggle-btn-active-class" class="k-toggle-btn" v-model="default_collection_sort_by" mandatory>
									<k-btn x-small width="90px" light :value="'title'" @click.stop="previous_default_collection_sort_by='title'">Title</k-btn>
									<k-btn x-small width="115px" light :value="'created_at'" class="k-tight-btn" @click.stop="set_created_at_sort_order">Date Created <k-icon :color="default_collection_sort_by == 'created_at' ? '#fff' : ''" class="ml-1" x-small>{{ created_at_sort_order_icon }}</k-icon></k-btn>
								</k-btn-toggle>								
							</div></template>{{default_collection_sort_by_tooltip}}</k-tooltip>
						</div>

						<k-spacer v-if="show_sort_by_control" />

						<k-text-field clearable dense flat rounded hide-details outlined solo
							v-model="folder_filter_text_model"
							class="k-collection-search-input mx-2"
							style="max-width: 320px"
							placeholder="Filter"
							prepend-inner-icon="fas fa-search"
						/>

						<k-spacer/>

						<k-tooltip bottom><template v-slot:activator="{on}"><k-btn v-show="at_least_one_folder_closed" v-on="on" x-small fab outlined color="#555" class="elevation-0 mr-3" @click="open_all_folders"><k-icon small>fas fa-angles-down</k-icon></k-btn></template>Open all folders</k-tooltip>
						<k-tooltip bottom><template v-slot:activator="{on}"><k-btn v-show="at_least_one_folder_open" v-on="on" x-small fab outlined color="#555" class="elevation-0 mr-3" @click="close_all_folders"><k-icon small>fas fa-angles-up</k-icon></k-btn></template>Close all folders</k-tooltip>
						<k-btn-toggle v-show="show_view_toggle_btns" dense active-class="k-toggle-btn-active-class" class="k-toggle-btn" v-model="collection_view_mode" mandatory>
							<k-btn x-small light :value="'tiles'" @click.stop="">Tile View</k-btn>
							<k-btn x-small light :value="'list'" @click.stop="">List View</k-btn>
						</k-btn-toggle>
					</div>
					<div v-if="!unit_has_resources" class="mt-5 text-center">
						<div v-if="unit_mode=='my_content'"><i>You have not created or copied any resources for this unit.</i></div>
						<div v-else><i>This {{collection.units.length>1?'unit':'collection'}} does not include any resources.</i></div>
					</div>
					<div class="k-collection-unit-wrapper-outer">

						<!-- show unit_plan links if we have any and we're not showing the shadow unit -->
						<div v-if="unit_mode!='my_content' && unit_plan_links.length>0" class="d-flex mb-3 mt-1">
							<k-spacer/>
							<div class="k-unit-plan-links">
								<div v-for="(link) in unit_plan_links" 
									:key="link.field" 
									class="k-unit-plan-link-outer elevation-1"
									@click="open_unit_plan_link(link)"
								>
									<div class="k-unit-plan-link-icon-outer"><k-icon :color="collection.color">{{link.icon}}</k-icon></div>
									<div class="k-unit-plan-link">{{link.text}}</div>
								</div>
							</div>
							<k-spacer/>
						</div>

						<div class="k-collection-unit-wrapper">
							<div class="k-collection-unit-resources mb-6">
								<CollectionResourceFolder
									ref="top_collection_resource_folder"
									:collection="collection"
									:unit="content_unit"
									:folder_id="'top'"
									:filter_text="folder_filter_text"
									:enable_collection_editing="enable_collection_editing"
									:term_mode="term_mode"
									:save_unit_edits="save_unit_edits"
									:user_can_edit_unit="user_can_edit_unit || is_default_collection"
									:published_asset_counts="published_asset_counts"
									@publish_all_unpublished="publish_all_unpublished"
									@unpublish_all="unpublish_all"
									@copy_to_shadow_unit_finish="copy_to_shadow_unit_finish"
									@resource_search_closed="cancel_unit_editing"
									@item_shift_update="$emit('item_shift_update',$event)"
								/>
							</div>
						</div>
					</div>
					<div v-if="false&&!is_collection_admin" class="mb-4 text-center"><k-btn outlined class="k-tight-btn k-nocaps-btn" color="primary" @click=""><k-icon small class="mr-2">fas fa-bolt</k-icon>Recommend a new Lesson, Student Activity or other Resource<k-icon small class="ml-2">fas fa-bolt</k-icon></k-btn></div>
					<div class="text-center">
						<k-btn small v-if="show_add_content_btn" class="k-edit-btn xk-tight-btn xk-nocaps-btn mx-1 mb-3 elevation-0" color="#ddd" @click="add_content"><k-icon class="mr-1" small>fas fa-plus</k-icon>Add Content</k-btn>
						<k-btn small v-if="user_can_edit_unit" class="k-edit-btn xk-tight-btn xk-nocaps-btn mx-1 mb-3 elevation-0" color="#ddd" @click="edit_unit"><k-icon class="mr-2" small>fas fa-edit</k-icon>Edit Unit</k-btn>
						<!-- <k-btn small v-if="user_can_edit_unit && published_asset_counts.unpublished" class="k-edit-btn xk-tight-btn xk-nocaps-btn mx-1 mb-3 elevation-0" color="#ddd" @click="publish_all_unpublished"><k-icon class="mr-2" small>fas fa-file-certificate</k-icon>Publish {{ published_asset_counts.unpublished }} unpublished asset{{ published_asset_counts.unpublished > 1 ? 's' : '' }}</k-btn> -->
						<k-btn small v-if="can_view_pd_report" class="k-edit-btn k-tight-btn xk-nocaps-btn mx-1 mb-3 elevation-0" color="#ddd" @click="show_todo_report=true"><k-icon class="mr-2" small>fas fa-list-check</k-icon>Show Resource Completion Report</k-btn>
						<k-btn small v-if="is_collection_admin&&collection.units.length==1" class="k-edit-btn k-tight-btn xk-nocaps-btn mx-1 mb-3 elevation-0" color="#ddd" @click="$emit('add_unit')"><k-icon small class="mr-2">fas fa-plus</k-icon>Add a new Unit to this Collection</k-btn>
					</div>
				</div>
			</div>
		</div>

		<!-- Standards -->
		<div class="" v-if="unit_mode == 'standards' && unit.standards.length > 0">
			<CollectionUnitStandards
				:lp="collection" :unit="unit"
				:is_collection_admin="is_collection_admin" 
				@edit_unit="edit_unit" 
				@copy_to_shadow_unit_finish="copy_to_shadow_unit_finish"
			/>
		</div>
	</div>

	<CollectionUnitEdit
		v-if="show_unit_editor"
		:collection="collection"
		:original_unit="unit"
		:instance_units="available_instance_units"
		:published_asset_counts="published_asset_counts"
		@publish_all_unpublished="publish_all_unpublished"
		@unpublish_all="unpublish_all"
		@editor_cancel="cancel_unit_editing"
		@editor_refresh="editor_refresh"
		@get_instance_units="$emit('get_instance_units')"
	/>

	<TodoReportCollectionUnit v-if="show_todo_report" :collection="collection" :unit="unit" @dialog_cancel="show_todo_report=false" />

	<UnpublishAllDialog v-if="show_unpublish_all_dialog" level="unit" :id="unit.lp_unit_id" @done="show_unpublish_all_dialog = false"/>
</div></template>

<script>
import goTo from 'vuetify/lib/services/goto'
import { mapState, mapGetters } from 'vuex'
import CollectionUnitStandards from './CollectionUnitStandards'
import CollectionResourceFolder from './CollectionResourceFolder'
import CollectionUnitEdit from './CollectionUnitEdit'
import TodoReportCollectionUnit from '../reports/TodoReportCollectionUnit'
import UnpublishAllDialog from './UnpublishAllDialog'

export default {
	name: 'CollectionUnit',
	components: { CollectionUnitStandards, CollectionResourceFolder, CollectionUnitEdit, TodoReportCollectionUnit, UnpublishAllDialog },
	props: {
		collection: { type: Object, required: true },
		unit: { type: Object, required: true },
		is_collection_admin: { type: Boolean, required: true },
		unit_descriptions_collapsed: { type: Boolean, required: false, default() { return false }},
		unit_show_full_description_btn: { type: Boolean, required: true },
		unit_description_style: { type: String, required: true },
		term_mode: { required: false, default() { return 'normal' }},
		instance_units: { required: true, type: Object },
		filtered_origin_teacher_id: { required: false, default() { return null } },
	},
	data() { return {
		initialized: false,
		is_collection_unit_component: true,	// used by CollectionResourceFolders to find this component
		show_todo_report: false,
		show_unit_editor: false,
		show_unpublish_all_dialog: false,
		shadow_unit: null,
		unit_mode: '',
		instance_selector_value: '',
		update_standards_count_trigger: 0,

		// pairing these two variables allows us to debounce
		folder_filter_text_model: '',
		folder_filter_text: '',
	}},
	computed: {
		...mapState(['user_info', 'lp_edit_locked', 'my_lessons', 'my_resources', 'my_ca_mappings', 'site_config', 'lst', 'framework_asset_counts']),
		...mapGetters(['studentish_role', 'my_default_collection', 'manage_assignments', 'use_message_center', 'show_all_items_when_not_signed_in', 'signed_in', 'unread_message_count', 'immediately_show_standards_aligned_resources']),
		unit_descriptions_collapsible() { return this.site_config.unit_descriptions_collapsible == 'yes' },
		unit_descriptions_collapsed_computed() { return this.unit_descriptions_collapsible && this.unit_descriptions_collapsed },
		unit_text() {
			// if we have a unit_plan, build the html here...
			if (this.unit.unit_plan?.is_set()) {
				let up = this.unit.unit_plan
				let banner_message = up.cp_scheme.cp_banner_message
				let scheme = up.cp_scheme.cp_components

				let html = ''

				// start with cp_banner_message if valid
				if (!empty(banner_message)) {
					// if the message has a field to be filled in, this should be a link
					if (banner_message.search(/\$(\w+)/) > -1) {
						let field = RegExp.$1
						// if this field is specified, add the message with the link; 
						if (!empty(up.cpc_text[field])) {
							banner_message = banner_message.replace(/\$(\w+)/, `<a href="${up.cpc_text[field]}" target="_blank" class="k-lesson-component-resource-anchor-link">${scheme[field].title}</a>`)

						// else we won't add the banner
						} else {
							banner_message = ''
						}
					}
					// else the message doesn't have a field to be filled in, so just add the banner
					if (!empty(banner_message)) {
						html += `<div class="k-collection-unit-plan-banner">${banner_message}</div>`
					}
				}

				// now each element of the scheme in sequence
				for (let field in scheme) {
					let cpc = scheme[field]
					let cpc_text = up.cpc_text[field]

					if (!empty(cpc_text)) {
						if (cpc.type == 'section') {
							html += `<div class="k-collection-unit-plan-section-header ${cpc.color} darken-3">`
								+ `<i class="${cpc.icon} mr-2"></i>`
								+ cpc.title
								+ `</div>`
								+ `<div class="k-collection-unit-plan-section-content">`
								+ U.marked_latex(cpc_text)
								+ `</div>`
						}
					}
				}

				return html

			// else (for now at least, look at unit.text
			} else {
				if (empty(this.unit.text)) return ''

				// annoying: text could have nothing but a "powered-by-froala" block; pull this out
				let div = $(`<div>${this.unit.text}</div>`)
				div.find('[data-f-id=pbf]').remove()
				return U.render_latex(div.html())
			}
		},

		unit_plan_links() {
			let arr = []
			if (this.unit.unit_plan?.is_set()) {
				let up = this.unit.unit_plan
				let scheme = up.cp_scheme.cp_components
				for (let field in scheme) {
					let cpc = scheme[field]
					if (cpc.type != 'link') continue

					let cpc_text = up.cpc_text[field]
					if (!empty(cpc_text)) {
						arr.push({
							field: field,
							icon: cpc.icon,
							text: cpc.title,
							url: cpc_text,
						})
					}
				}
			}
			return arr
		},

		is_flex_unit() {
			return this.unit?.is_flex_unit ?? false
		},
		is_instance_unit() {
			return this.unit?.instance_unit_of !== 0 ?? false
		},
		flex_unit_id() {
			if (!this.is_flex_unit && !this.is_instance_unit) return 0
			return this.is_flex_unit ? this.unit.lp_unit_id : this.unit.instance_unit_of
		},
		available_instance_units() {
			// The instance_units object prop includes all instance units for the collection, keyed to flex unit IDs
			// For convenience, we limit it here to just the instance unit children of the current flex unit
			if (!this.flex_unit_id || this.flex_unit_id === 0) return []
			return [...this.instance_units[`${this.flex_unit_id}`] ?? []]
		},
		show_instance_selector() {
			// If this is a flex unit or instance unit AND there are multiple instance units available for this flex unit,
			//  we render the unit title in a drop-down that allows the user to select which unit to view
			return ((this.is_flex_unit || this.is_instance_unit) && this.available_instance_units.length > 0)
		},
		instance_selector_options() {
			//  If we are currently showing an instance unit, we want to include the parent Flex Unit in the dropdown for instance units
			if (this.is_instance_unit) {
				const flex_unit = this.collection.units.find(u => u.lp_unit_id == this.unit.instance_unit_of)
				if (flex_unit) return [flex_unit, this.unit, ...this.available_instance_units]
			}
			// Otherwise, this.unit == flex unit
			return [this.unit, ...this.available_instance_units]
		},
		content_unit() {
			// if this isn't an agency_sanctioned unit, or this isn't a teacher-level user, or unit_mode isn't 'my_content', show the "base" unit content
			if (!this.is_agency_sanctioned_collection) return this.unit
			if (this.studentish_role) return this.unit
			if (this.unit_mode != 'my_content' && this.unit_mode != 'assignments') return this.unit
			
			// if we get to here this is an agency_sanctioned lp being viewed by a teacher and unit_mode is 'my_content' or 'assignment', so show the teacher's "shadow unit", which we (currently) create locally, on the fly, below
			return this.shadow_unit
		},
		title_for_header() {
			if (this.is_instance_unit) {
				const flex_unit = this.collection.units.find(u => u.lp_unit_id == this.unit.instance_unit_of)
				return `<b style="font-size:0.8em">${flex_unit.title}:</b> ${this.unit.title}`
			} else {
				return this.unit.title
			}
		},
		is_default_collection() { return (this.collection.course_code == 'default') },
		is_agency_sanctioned_collection() { return this.collection.agency_sanctioned },
		show_resources_tab() { 
			// always show resources tab for all collection types other than 'course'
			if (this.collection.collection_type != 'course') return true

			// if we're not showing the standards tab (because there are no standards specified), always show the resources tab
			if (!this.show_standards_tab) return true

			// if site_config set to always show
			if (this.site_config.always_show_collection_unit_resource_tab) return true

			// if we get to here, show the resources tab if we have content tied to the collection itself (not counting a user's my resources)
			if (this.unit?.resources.length > 0) return true
			if (this.unit?.lessons.length > 0) return true
			
			return false
		},
		show_standards_tab() { return this.unit.standards.length > 0 },
		show_assignments_tab() { return this.collection.collection_type == 'course' && this.shadow_unit != null && this.manage_assignments },
		show_my_content_tab() { 
			if (this.shadow_unit == null) return false

			if (this.is_flex_unit || this.is_instance_unit) return false

			// for courses, 
			if (this.collection.collection_type == 'course') {
				// show the my content tab if we're not managing assignments (you can't be both managing assignments and using my content for the same collection/unit at the same time, because they use the same data to determine what is "my content" and what is a directive)
				return !this.manage_assignments
			} else {
				// else you can have "my content" for repos (but not "pd" or "my" collections)
				return this.collection.collection_type == 'repo'
			}
		},
		show_messages_tab() { return this.collection.collection_type == 'course' && this.use_message_center && this.signed_in },
		show_assignments() { return this.show_assignments_tab && this.unit_mode === 'assignments' },
		show_messages() { return this.show_messages_tab && this.unit_mode === 'messages' },
		show_unit_mode_toggle() {
			// show the toggle button if we're showing at least two buttons...
			let n_btns = 0
			if (this.show_resources_tab) n_btns += 1
			if (this.show_standards_tab) n_btns += 1
			if (this.show_my_content_tab) n_btns += 1
			if (this.show_assignments_tab) n_btns += 1
			if (this.show_messages_tab) n_btns += 1
			return n_btns > 1
		},

		// allow config to define the order, style, and text of the "mode" buttons
		unit_mode_btn_order() {
			if (this.site_config.unit_mode_btn_order) return this.site_config.unit_mode_btn_order
			else return [
				'resources',
				'standards',
				'my_content',
				'assignments',
				'messages',
			]
		},

		// Customized Unit Toggle button titles from config
		resources_button_text() { return this.site_config.unit_mode_toggle_option?.resources || 'Resources' },
		standards_button_text() { return this.site_config.unit_mode_toggle_option?.standards || 'Standards' },
		my_content_button_text() { return this.site_config.unit_mode_toggle_option?.my_content || 'My Content' },
		assignment_center_button_text() {
			if (!this.manage_assignments) return ''
			const button_text = this.site_config.unit_mode_toggle_option?.assignments || 'Activities'
			if (this.role == 'parent') return button_text	// My Child’s
			else if (this.role == 'student') return button_text
			else return `My Lessons & ${button_text}`
		},
		messages_button_text() {
			const button_text = this.site_config.unit_mode_toggle_option?.messages || 'Message Center'
			const n = this.unread_message_count(this.collection.course_code)
			return `${button_text}${n ? ` (${n})` : ''}`
		},

		unit_mode_btn_data() {
			let o = {
				resources: {show: this.show_resources_tab, style: 'min-width:136px;', button_text: 'Resources', icon: 'fas fa-box-archive' },
				standards: {show: this.show_standards_tab, style: 'min-width:136px;', button_text: 'Standards', icon: 'fas fa-bullseye' },
				my_content: {show: this.show_my_content_tab, style: 'min-width:136px;', button_text: 'My Content', icon: 'fas fa-cubes-stacked' },
				assignments: {show: this.show_assignments_tab, style: 'min-width:176px;', button_text: 'Activities', icon: 'fas fa-bolt' },
				messages: {show: this.show_messages_tab, style: 'min-width:176px;', button_text: 'Message Center', icon: 'fas fa-comments' },
			}

			// config can specify styles with unit_mode_btn_style
			if (this.site_config.unit_mode_btn_style) {
				for (let key in this.site_config.unit_mode_btn_style) {
					o[key].style = this.site_config.unit_mode_btn_style[key]
				}
			}

			// config can specify icons with unit_mode_btn_icon
			if (this.site_config.unit_mode_btn_icon) {
				for (let key in this.site_config.unit_mode_btn_icon) {
					o[key].icon = this.site_config.unit_mode_btn_icon[key]
				}
			}

			// config can specify button_text with unit_mode_toggle_option
			if (this.site_config.unit_mode_toggle_option) {
				for (let key in this.site_config.unit_mode_toggle_option) {
					o[key].button_text = this.site_config.unit_mode_toggle_option[key]
				}
			}

			// make some adjustments
			o.resources.button_text += ` (${this.base_unit_resource_count_display})`
			if (this.standards_count > -1) o.standards.button_text += ` (${this.standards_count})`
			o.my_content.button_text += ` (${this.shadow_unit_resource_count})`
			o.assignments.button_text += ` (${this.shadow_unit_resource_count})`

			return o
		},

		viewing_shadow_unit() { return (this.unit_mode == 'my_content' && this.show_my_content_tab) },
		viewing_users_shadow_unit() { return (this.viewing_shadow_unit && this.shadow_unit.shadow_unit_owner_id == this.user_info.user_id) },
		show_sort_by_control() {
			if (this.is_default_collection) return true
			if (this.unit_mode == 'my_content') return true
			return false
		},
		user_is_instance_unit_admin() {
			if (this.is_collection_admin) return true
			return this.user_info.admin_rights.includes(`admin_instance.unit.${this.unit.lp_unit_id}`)
		},
		user_is_instance_unit_editor() {
			if (this.is_collection_admin || this.user_is_instance_unit_admin) return true
			return this.user_info.admin_rights.includes(`edit_instance.unit.${this.unit.lp_unit_id}`)
		},
		show_add_content_btn() {
			if (this.is_instance_unit) return this.user_is_instance_unit_editor

			// if you're viewing your shadow unit or in default collection, you can add content (we don't have folders in the shadow unit)
			if (this.viewing_users_shadow_unit || this.is_default_collection) return true

			// otherwise unless your a collection admin, you surely won't be able to add content
			if (!this.is_collection_admin) return false

			// now, if the unit doesn't have any folders, allow to add content directly to the unit (if there there is only 1 folder, it is the 'top' folder, which isn't a folder the user added)
			if (this.unit.resource_tree.folders.length <= 1) return true
			return false
		},
		user_can_edit_unit() {
			if (this.is_instance_unit) {
				if (this.is_collection_admin) return true
				const unit_id = this.unit.lp_unit_id
				const user_is_editor = this.user_info.admin_rights.includes(`admin_instance.unit.${unit_id}`) || this.user_info.admin_rights.includes(`edit_instance.unit.${unit_id}`)
				return user_is_editor
			} else {
				return (this.is_collection_admin && !this.is_default_collection && this.unit_mode != 'my_content')
			}
		},
		// Get the course guidance items from unit 1 in an object
		course_guidance_items() {
			// for the 'Resources for Course Guidance' folder in HenryConnects, we want to include items from other course_guidance folders in the same collection...
			// here we get the list of extra items from other units; we then use this to accurately reflect the count of resources, and show the extra resources in the course guidance folder
			/** 
			 * { resource_for_course_guidance_folder: {
			 * 		items: [item, item, item,...]
			 * 		parent_folder_id: 'top'
			 * 		title: folder_title,
			 * 		count: count of all resources in folder(s)
			 * 		...
			 * 	 },
			 *   {subfolder_id}: {
			 * 		items: [item, item, item,...]
			 * 		parent_folder_id: {parent_folder_id}
			 * 		title: folder_title
			 * 		count: count of all resources in folder(s)
			 * 		...
			 * 	 }
			 * } 
			 */
			let obj = {}
			const resources_in_unit_1 = this.collection.units[0].resources.reduce((a, v) => { a[v.resource_id] = v; return a; }, {})
			const lessons_in_unit_1 = this.collection.units[0].lessons.reduce((a, v) => { a[v.lesson_id] = v; return a; }, {})
			const this_unit_course_guidance_folder = this.unit.find_course_guidance_folder()
			const get_course_guidance_items = (root) => {
				if (!root) return 0
				// Create the object
				const key = LP_Unit.folder_is_course_guidance(root) ? 'course_guidance' : root.folder_id
				if (!obj[key]) obj[key] = {parent_folder_id: root.parent_folder_id, items: [], title: root.title, count: 0}
				for (const child_id of root.children) {
					if (child_id in resources_in_unit_1) {
						obj[key].items.push(resources_in_unit_1[child_id])
					}
					if (child_id in lessons_in_unit_1) {
						obj[key].items.push(lessons_in_unit_1[child_id])
					}
					obj[key].count += 1
				}
				// Create the new folders for the unit
				if (root.parent_folder_id !== 'top' && !this.unit.resource_tree.folders.find(x => x.folder_id === root.folder_id)) {
					if (LP_Unit.folder_is_course_guidance(root) && !empty(this_unit_course_guidance_folder)) {
						this.unit.create_resource_folder({parent_folder_id: this_unit_course_guidance_folder.folder_id, folder_id: root.folder_id, title: root.title, seq: root.seq, color: root.color })
					} else {
						this.unit.create_resource_folder({parent_folder_id: root.parent_folder_id, folder_id: root.folder_id, title: root.title, seq: root.seq, color: root.color })
					}
				}
				for (const folder of this.collection.units[0].resource_tree.folders) {
					if (folder.parent_folder_id === root.folder_id) {
						obj[key].count += get_course_guidance_items(folder)
					}
				}
				return obj[key].count
			}
			const root = this.collection.units[0].find_course_guidance_folder()
			if (root && root.children.length > 0) get_course_guidance_items(root)

			return obj
		},
		base_unit_resource_count() {
			// lessons that are loaded are viewable if not restricted or this isn't a student (studentish people may also not get some lessons loaded)
			let n = 0
			for (let lesson of this.unit.lessons) {
				// exclude if collection.asset_visible_for_count says it should be hidden
				if (!this.collection.asset_visible_for_count(lesson, this.user_can_edit_unit)) {
					continue
				}
				++n
			}

			// for resources we have to do some other checks, as in CollectionResourceFolder
			for (let resource of this.unit.resources) {
				// hide/show items marked as block or traditional; note that 'traditional' resource == 'normal' term_mode; but don't hide when editing
				if (!this.enable_collection_editing) {
					if (resource.block_or_traditional == 'block' && this.term_mode != 'block') continue
					if (resource.block_or_traditional == 'traditional' && this.term_mode != 'normal') continue
				}

				if (!this.show_all_items_when_not_signed_in && this.studentish_role && this.collection.collection_type == 'course') {
					// the user can't see the item unless it's explicicly marked as family_avail, or it's part of a tcc collection
					if (!resource.family_avail && !resource.tcc_folder_id) continue
				}

				// items marked as leader_resource can only be viewed by admins and principals/assistant principals
				if (resource.lp_category == 'leader_resource') {
					if (!(this.$store.getters.user_is_principal_or_ap || this.is_collection_admin)) {
						continue
					}
				}

				// also exclude if collection.asset_visible_for_count says it should be hidden
				if (!this.collection.asset_visible_for_count(resource, this.user_can_edit_unit)) {
					continue
				}

				++n
			}

			// check for special course_guidance resources
			if (this.unit.lp_unit_id !== this.collection.units[0].lp_unit_id && this.course_guidance_items['course_guidance']) n += this.course_guidance_items['course_guidance'].count
			return n
		},
		base_unit_resource_count_display() {
			// start with the count of resources we know about...
			let s = this.base_unit_resource_count + ''

			// if the unit includes a tcc folder, we won't know exactly how many resources are there, so add a '+'
			if (this.$refs.top_collection_resource_folder?.includes_tcc_folder) {
				s += '+'
			}
			return s
		},
		shadow_unit_resource_count() {
			if (!this.shadow_unit) return 0
			// note: the user can definitionally see all items in their shadow unit	
			return this.shadow_unit.lessons.length + this.shadow_unit.resources.length
		},
		standards_count() {
			if (this.unit.standards.length == 0) return 0

			// if this site_config setting is 'yes', show a count of all assets aligned to the unit (ALEX, where the header for this tab is "Content By Standard")
			if (this.site_config.show_resource_count_in_unit_standards_tag == 'yes') {
				if (this.update_standards_count_trigger < 0) return -1

				// add up alignments for all standards in the unit; load framework_asset_counts as we go if needed
				let asset_count = 0
				for (let standard of this.unit.standards) {
					if (!empty(standard.framework_identifier)) {
						let fac = this.framework_asset_counts[standard.framework_identifier]
						// try to load the asset_counts and return; Vue will send control back here and re-calculate when done
						if (fac == 'loading') return -1
						if (empty(fac)) {
							this.$store.dispatch('get_framework_asset_counts', standard.framework_identifier).then(x=>{
								++this.update_standards_count_trigger
							})
							return -1
						}

						// if we get to here we have the asset_counts, so add for this standard
						asset_count += (fac[standard.identifier] || 0)
					}
				}
				return asset_count

			} else {
				// else return a count of the number of unit standards
				return this.unit.standards.length
			}
		},
		enable_collection_editing() {
			// for most collections, the user has to click the edit button to edit the unit
			// but for the default collection, and shadow units, we don't allow for the edit button, so show editing functionality (e.g. remove) from here
			return this.is_default_collection || this.viewing_users_shadow_unit
		},
		show_view_toggle_btns() {
			// in pd collections or when viewing the shadow unit, we always show 'list' view, so don't show the toggler
			if (this.$store.getters.lti_chooser) return false
			if (this.collection.collection_type == 'pd') return false
			if (this.viewing_shadow_unit) return false
			return true
		},
		// this must be kept in synch with the computed in CollectionResourceFolder
		collection_view_mode: {
			get() {
				if (this.$store.getters.lti_chooser) return 'list'
				if (this.collection.collection_type === 'pd') return 'list'
				if (this.viewing_shadow_unit) return 'list'
				return this.$store.state.lst.collection_view_mode
			},
			set(val) { this.$store.commit('lst_set', ['collection_view_mode', val]) }
		},
		default_collection_sort_by: {
			get() { return this.$store.state.lst.default_collection_sort_by },
			set(val) { this.$store.commit('lst_set', ['default_collection_sort_by', val]) }
		},
		default_collection_sort_by_tooltip() {
			if (this.default_collection_sort_by == 'title') return 'Sorted by title'
			if (this.$store.state.lst.default_collection_sort_by_created_at_order == 'asc') return 'Sorted by Date Created (oldest first)'
			return 'Sorted by Date Created (newest first)'
		},
		created_at_sort_order_icon() {
			if (this.default_collection_sort_by == 'title') return ''
			if (this.$store.state.lst.default_collection_sort_by_created_at_order == 'asc') return 'fas fa-arrow-up-short-wide'
			return 'fas fa-arrow-down-wide-short'
		},
		unit_has_resources() {
			if (!this.content_unit) return false
			if (!this.signed_in && this.base_unit_resource_count == 0) return false

			// if the unit includes a tcc folder, there may be resources there
			if (this.$refs.top_collection_resource_folder?.includes_tcc_folder) return true

			// PW 10/24/2025: I'm not sure if the 3 checks after this one are needed; I think they would all be part of base_unit_resource_count
			if (this.base_unit_resource_count > 0) return true

			// check for special course_guidance resources
			if (this.course_guidance_items['course_guidance']?.count > 0) return true

			if (this.content_unit.resources.length > 0) return true
			if (this.content_unit.lessons.length > 0) return true

			return false
		},
		can_view_pd_report() {
			// only applicable for PD collections
			if (this.collection.collection_type != 'pd') return false
			return vapp.has_admin_right('pd_rep.any')
		},
		at_least_one_folder_closed() {
			let cof = this.$store.state.lst.collections_opened_folders
			let folder_closed = (folder_id) => {
				if (folder_id != 'top' && !cof[folder_id]) return true

				for (let f of this.content_unit.resource_tree.folders) {
					if (f.parent_folder_id == folder_id) {
						if (folder_closed(f.folder_id)) return true
					}
				}
				return false
			}
			return folder_closed('top')
		},
		at_least_one_folder_open() {
			let cof = this.$store.state.lst.collections_opened_folders
			let folder_open = (folder_id) => {
				if (folder_id != 'top' && cof[folder_id] == 'open') return true

				for (let f of this.content_unit.resource_tree.folders) {
					if (f.parent_folder_id == folder_id) {
						if (folder_open(f.folder_id)) return true
					}
				}
				return false
			}
			return folder_open('top')
		},
		folder_icon_css() {
			// return U.subject_tile_css(this.collection) + '-text'
			return U.collection_color_style(this.collection, 'text')
		},
		resources_header_text() {
			if (this.is_default_collection || this.unit_mode == 'my_content') {
				// for the default collection, the units are named after the types;
				// and for "my content", the folders are named after the types
				return ''
			} else {
				return this.site_config.unit_mode_toggle_option?.resources || 'Resources'
			}
		},
		published_asset_counts() {
			let counts = {published: 0, unpublished: 0}
			if (!this.collection.agency_sanctioned) return counts


			this.unit.lessons.forEach(x => {
				if (!x.agency_sanctioned) {
					counts.unpublished++
				} else {
					counts.published++
				}
			})

			this.unit.resources.forEach(x => {
				if (!x.agency_sanctioned) {
					counts.unpublished++
				} else {
					counts.published++
				}
			})
			
			return counts
		},
	},
	watch: {
		my_lessons: { deep:true, handler() { this.create_shadow_unit() }},
		my_resources: { deep:true, handler() { this.create_shadow_unit() }},
		my_ca_mappings: { deep:true, handler() { this.create_shadow_unit() }},
		'unit.lp_unit_id': { deep:false, handler() { 
			this.initialize_unit()
		}},
		folder_filter_text_model() {
			// establish the debounce fn if necessary
			if (empty(this.folder_filter_text_debounced)) {
				this.folder_filter_text_debounced = U.debounce(function(x) {
					this.folder_filter_text = this.folder_filter_text_model
				}, 500)
			}
			// when folder_filter_text_model is cleared, clear folder_filter_text immediately
			if (empty(this.folder_filter_text_model)) {
				this.folder_filter_text = ''
			} else {
				// else call the debounce fn
				this.folder_filter_text_debounced()
			}
		},
	},
	created() {
		this.initialize_unit()

		vapp.collection_unit_component = this
	},
	mounted() {
		this.previous_default_collection_sort_by = this.default_collection_sort_by
	},
	methods: {
		async initialize_unit() {
			// don't let a folder filter typed in one unit carry over when switching to another unit
			this.folder_filter_text_model = ''

			// if unit is not fully-loaded, load it now
			if (!this.unit.fully_loaded) {
				// first set initialized to false, since we will often be called by the watcher
				this.initialized = false
				console.warn(`initialize_unit (LOADING): ${this.collection.title} / ${this.unit.display_number}: ${this.unit.title}`)
				let params = { 
					lp_id: this.collection.lp_id,
					lp_unit_ids: [this.unit.lp_unit_id],
				}

				// try to load it now
				let rv = await this.$store.dispatch('get_full_units', params)

			} else {
				console.warn(`initialize_unit (already loaded): ${this.collection.title} / ${this.unit.display_number}: ${this.unit.title}`)
			}

			this.create_shadow_unit()
			this.set_initial_unit_mode()
			this.initialized = true
		},

		unit_mode_changed(val) {
			this.$store.commit('lst_set', ['unit_mode', val])
		},

		set_initial_unit_mode() {
			// set initial value for unit_mode
			if (!this.show_unit_mode_toggle) {
				// in the case where we're not even showing the unit mode toggle (e.g. my and pd collections), unit_mode has to be the one mode we're showing
				if (this.show_resources_tab) this.unit_mode = 'resources'
				if (this.show_standards_tab) this.unit_mode = 'standards'
				if (this.show_my_content_tab) this.unit_mode = 'my_content'
				if (this.show_assignments_tab) this.unit_mode = 'assignments'
				if (this.show_messages_tab) this.unit_mode = 'messages'

			} else {
				// start with the value from lst, but then correct if necessary based on the circumstances
				this.unit_mode = this.$store.state.lst.unit_mode
				if (!this.show_standards_tab && this.unit_mode == 'standards') this.unit_mode = 'resources'
				else if (!this.show_resources_tab && this.unit_mode == 'resources') this.unit_mode = 'standards'
				else if ((!this.show_my_content_tab && this.unit_mode == 'my_content')
					|| (!this.show_assignments && this.unit_mode == 'assignments')
					|| (!this.show_messages_tab && this.unit_mode == 'messages')) {
						// we should always be showing either the resources tab or the standards tab
						if (this.show_resources_tab) this.unit_mode = 'resources'
						else this.unit_mode = 'standards'
					}
			}
			// if the user is viewing the toggle, and clicks to change the toggle, we will update lst in unit_mode_changed below
		},

		select_instance_unit(instance_unit) {
			// if user hits backspace to clear the autocomplete value, select the flex unit
			if (empty(instance_unit)) instance_unit = this.flex_unit

			// add new default instance unit to LST, keyed to the flex unit id
			const o = this.lst.default_instance_unit
			const flex_unit_id = this.is_instance_unit ? this.unit.instance_unit_of : this.unit.lp_unit_id
			o[`${flex_unit_id}`] = instance_unit.lp_unit_id
			this.$store.commit('lst_set', ['default_instance_unit', o])

			// Change view to show selected instance unit
			this.$emit('toggle_unit', instance_unit)
			// this.$emit('toggle_unit', new LP_Unit(instance_unit))

			// remove focus from the autocomplete
			this.$refs.instance_selector.blur()
			// clear this.instance_selector_value after a tick; that clears the autocomplete
			setTimeout(x=>this.instance_selector_value = '', 0)
		},

		// this is where we, on the fly, create the "shadow" unit for the user, which includes items that they've copied from this unit, or items that they've created in this unit
		create_shadow_unit() {
			// parents/students currently can't do anything with resource copies, so no need for a shadow unit for them
			if (this.studentish_role) return

			// no need for shadow units in the default collection
			if (this.is_default_collection) return

			// no need, at least currently, for shadow units in other non-agency_sanctioned collections either
			if (!this.collection.agency_sanctioned) return

			// if we are in a flex or instance unit, we can eject
			if (this.is_flex_unit || this.is_instance_unit) return

			// console.warn('CollectionUnit: create_shadow_unit: ' + this.unit.lp_unit_id)

			// for non-studentish users, we always create the shadow unit for collections: we only show the "My Content" tab for agency-sanctioned collections, but for non-agency-sanctioned collections, we use the shadow unit to manage copies of the resources for students

			// create the shadow unit with 'my' lessons and resources tagged to this lp_unit_id
			let lessons = []
			for (let lesson of this.unit.lessons) {
				// note that we look both in my_xxx and in the default collection
				let copy = this.my_lessons.find(x=>x.lesson_template_id == lesson.lesson_id)
				if (!copy) copy = this.my_default_collection.units[0].lessons.find(x=>x.lesson_template_id == lesson.lesson_id)
				if (copy) lessons.push(copy)
			}
			let sparkl_activities = []
			let link_resources = []
			for (let resource of this.unit.resources) {
				// note that we look both in my_xxx and in the default collection
				let copy = this.my_resources.find(x=>x.resource_template_id == resource.resource_id)
				if (!copy) {
					if (resource.type == 'sparkl') copy = this.my_default_collection.units[1].resources.find(x=>x.resource_template_id == resource.resource_id)
					else copy = this.my_default_collection.units[2].resources.find(x=>x.resource_template_id == resource.resource_id)
				}
				if (copy) {
					if (resource.type == 'sparkl') sparkl_activities.push(copy)
					else link_resources.push(copy)
				}
			}

			// add items created by the user and expressly tagged to the unit
			for (let ca_mapping of this.my_ca_mappings) {
				if (ca_mapping.collection_id == this.collection.lp_id && ca_mapping.unit_id == this.unit.lp_unit_id) {
					if (ca_mapping.asset_type == 'lesson') {
						let item = this.my_lessons.find(x=>x.lesson_id == ca_mapping.asset_id)
						if (item && !lessons.find(x=>x.lesson_id == item.lesson_id)) lessons.push(item)
					} else {
						let item = this.my_resources.find(x=>x.resource_id == ca_mapping.asset_id)
						if (item) {
							if (item.type == 'sparkl' && !sparkl_activities.find(x=>x.resource_id == item.resource_id)) sparkl_activities.push(item)
							if (item.type != 'sparkl' && !link_resources.find(x=>x.resource_id == item.resource_id)) link_resources.push(item)
						}
					}
				}
			}

			// sort in alpha order; CollectionResourceFolder will change to date if necessary
			lessons.sort((a,b)=>U.natural_sort(a.lesson_title, b.lesson_title))
			sparkl_activities.sort((a,b)=>U.natural_sort(a.description, b.description))
			link_resources.sort((a,b)=>U.natural_sort(a.description, b.description))

			// create the shadow_unit, then add folders for lessons and resources
			let unit = new LP_Unit({
				shadows_lp_id: this.collection.lp_id,
				shadows_lp_unit_id: this.unit.lp_unit_id,
				shadow_unit_owner_id: this.user_info.user_id,
				lessons: lessons,
				resources: sparkl_activities.concat(link_resources),
				title: this.unit.title,
			})
			// by giving the units consistent folder_ids, we'll remember what's open in lst
			if (lessons.length > 0) unit.create_resource_folder({parent_folder_id:'top', title:'My Lessons', items: lessons, color:'blue', folder_id:`shadow-folder-${this.unit.lp_unit_id}-${this.user_info.user_id}-lessons`})
			if (sparkl_activities.length > 0) unit.create_resource_folder({parent_folder_id:'top', title:`My ${this.site_config.sparkl_app_name} Student Activities`, items: sparkl_activities, color:'purple', folder_id:`shadow-folder-${this.unit.lp_unit_id}-${this.user_info.user_id}-sparkl_activities`})
			if (link_resources.length > 0) unit.create_resource_folder({parent_folder_id:'top', title:'My Other Resources', items: link_resources, color:'orange', folder_id:`shadow-folder-${this.unit.lp_unit_id}-${this.user_info.user_id}-link_resources`})

			this.shadow_unit = unit
		},

		toggle_unit_descriptions_collapsed() {
			this.$store.commit('lst_set', ['unit_descriptions_collapsed', !this.unit_descriptions_collapsed])
		},

		set_created_at_sort_order(val) {
			if (this.previous_default_collection_sort_by == 'created_at') {
				if (this.$store.state.lst.default_collection_sort_by_created_at_order == 'desc') this.$store.commit('lst_set', ['default_collection_sort_by_created_at_order', 'asc'])
				else this.$store.commit('lst_set', ['default_collection_sort_by_created_at_order', 'desc'])
			}
			this.previous_default_collection_sort_by = 'created_at'
		},

		narrow_window() {
			return $(window).width() < 1000
		},

		open_all_folders() {
			let cof = extobj(this.$store.state.lst.collections_opened_folders)
			for (let f of this.content_unit.resource_tree.folders) {
				// don't open all tcc folders -- that will take too long for big collections
				if (!f.has_rcis && !f.tcc_folder_id) {
					cof[f.folder_id] = 'open'
				}
			}
			this.$store.commit('lst_set', ['collections_opened_folders', cof]) 
		},

		close_all_folders() {
			let cof = extobj(this.$store.state.lst.collections_opened_folders)
			for (let f of this.content_unit.resource_tree.folders) delete cof[f.folder_id]
			this.$store.commit('lst_set', ['collections_opened_folders', cof]) 
		},

		edit_unit() {
			// the collection's units must all be fully loaded to edit; 
			// otherwise, when we save, unloaded units' folder assignments will be lost
			if (!this.collection.units_fully_loaded()) {
				U.loading_start()
				let params = {
					course_code: this.collection.course_code,
					force_reload: true
				}
				this.$store.dispatch('get_learning_progression', params).then((found)=>{
					U.loading_stop()
					this.$nextTick(x=>this.edit_unit())
				})
				return
			}

			// we have to request to edit the collection, to make sure no one else already has the lp opened for editing -- but not for the default collection
			if (this.is_default_collection) {
				this.show_unit_editor = true
				return
			}

			this.$store.dispatch('edit_access_control', {lp_id: this.collection.lp_id, lp_updated_at: this.collection.updated_at, action: 'checkout'}).then((result)=>{
				this.show_unit_editor = true

			}).catch((e)=>{
				// if this doesn't work, don't enter edit mode
				console.error('error requesting editor checkout for collection unit', e)
			})
		},

		cancel_unit_editing() {
			// when editing is canceled, clear the edit lock. Note that we do this both when the unit editor is closed and when the ResourceSearch dialog is closed
			if (!this.is_default_collection && !this.viewing_shadow_unit) this.$store.dispatch('edit_access_control_checkin', {lp_id: this.collection.lp_id})
			this.$refs.top_collection_resource_folder?.import_tcc_items()
			this.show_unit_editor = false
		},

		editor_refresh() {
			if (this.is_flex_unit) this.$emit('get_instance_units')
			this.cancel_unit_editing()
			this.$nextTick(() => this.edit_unit())
		},

		add_content() {
			// if we're viewing the default collection, or a user's shadow unit, just start the process
			if (this.is_default_collection || this.viewing_users_shadow_unit) {
				this.$refs.top_collection_resource_folder.search_start()
				return
			}
			
			// adding content is the same as editing the unit, and the collection's units must all be fully loaded to edit; 
			// otherwise, when we save, unloaded units' folder assignments will be lost
			if (!this.collection.units_fully_loaded()) {
				U.loading_start()
				let params = {
					course_code: this.collection.course_code,
					force_reload: true
				}
				this.$store.dispatch('get_learning_progression', params).then((found)=>{
					U.loading_stop()
					this.$nextTick(x=>this.add_content())
				})
				return
			}

			// ...then we have to request to edit the unit, to make sure no one else already has the lp opened for editing
			this.$store.dispatch('edit_access_control', {lp_id: this.collection.lp_id, lp_updated_at: this.collection.updated_at, action: 'checkout'}).then(() => {
				this.$refs.top_collection_resource_folder.search_start()

			}).catch((e)=>{
				// if this doesn't work, don't enter edit mode
				console.error('error requesting editor checkout for collection unit add_content', e)
			})
		},

		// this fn is called when the CollectionResourceFolder emits save_unit_edits
		save_unit_edits(flag) {
			return new Promise((resolve, reject) => {
				// if we're viewing a shadow unit or the sandbox,
				if (this.viewing_users_shadow_unit || this.is_default_collection) {
					// just resolve; the code that called this fn should proceed to update the mappings, which is all we need to do for the shadow unit or sandbox.
					resolve()
				// else we're editing a "real" collection, so save the lp
				} else {
					// the only place where a CollectionUnit CollectionResourceFolder (as opposed to a CollectionUnitEdit CollectionResourceFolder)
					// should be calling save_unit_edits is when the user has clicked to 'ADD CONTENT' to a unit that doesn't already have a folder structure.
					// in this case, add_content above will have been called, which will ensure that the all collection unit contents are fully loaded
					// CollectionResourceFolder will have made the necessary updates to the resources or lessons array of the unit, so we just have to dispatch save_learning_progression

					// TODO: purge instance unit code
					// However, we have to handle Instance Units differently because they don't live in collection.units
					if (this.is_instance_unit) {
						const payload = {
							user_id: this.user_info.user_id,
							unit_data: JSON.stringify(this.unit.copy_for_save())
						}
						U.ajax('edit_instance_unit', payload, result => {
							U.loading_stop()
							if (result.status != 'ok') {
								console.error('Error in ajax call'); vapp.ping(); return;
							}
							this.$emit('get_instance_units')
							resolve()
						})

					} else {
						this.$store.dispatch('save_learning_progression', this.collection).then(() => {
							// if flag is 'then_checkin', immediately remove the edit lock now
							if (flag == 'then_checkin') {
								this.$store.dispatch('edit_access_control_checkin', {lp_id: this.collection.lp_id})
							}
							resolve()
						})
					}
				}
			})
		},

		get_item_type(copied_item) {
			if (!empty(copied_item.lesson_id)) {
				return 'lesson'
			} else if (copied_item.type == 'sparkl') {
				return 'sparkl'
			} else {
				return 'resource'
			}
		},

		// Adapted from copy_to_my_content_finish, but genericized to support both 'my_content' and 'assignment' workflows
		copy_to_shadow_unit_finish(copied_item) {
			const item_type = this.get_item_type(copied_item)
			let msg
			if (this.manage_assignments && this.collection.collection_type == 'course') {
				msg = {
					lesson: 'A copy of the lesson plan has been added to the “My Lessons & Activities” area of this Unit. It will also appear in your Content Sandbox.<br><br>To start editing the lesson now, click OK, then click the <i class="fas fa-edit blue--text text--darken-2 mx-1"></i> Edit button at the bottom of the lesson dialog.',
					sparkl: 'A copy of the activity has been added to the “My Lessons & Activities” area of this Unit. It will also appear in your Content Sandbox.<br><br>You can use the activity with your students, and/or modify the activity if you wish, now.',
					// ??? would this ever happen?
					resource: 'The resource has been imported to the “My Lessons & Activities” area of this Unit. It will also appear in your Content Sandbox.'
				}[item_type]
			} else {
				msg = {
					lesson: 'A copy of the lesson has been imported for your use. It will appear in the “My Content” area of this Unit, as well as in your Content Sandbox.<br><br>To start editing the lesson now, click OK, then click the <i class="fas fa-edit blue--text text--darken-2 mx-1"></i> Edit button at the bottom of the lesson dialog.',
					sparkl: 'A copy of the activity has been imported for your use. It will appear in the “My Content” area of this Unit, as well as in your Content Sandbox.<br><br>You can use the activity with your students, and/or modify the activity if you wish, now.',
					resource: 'The resource has been imported to your “My Content” area. It will also appear in your Content Sandbox.'
				}[item_type]
			}

			if (this.site_config.copied_for_my_use_warning) {
				msg += `<div class="mt-3 pt-3 px-5" style="border-top:1px solid #ccc; font-size:14px; line-height:18px;">${this.site_config.copied_for_my_use_warning}</div>`
			}

			// push to the shadow unit
			const target_array = item_type === 'lesson' ? this.shadow_unit.lessons : this.shadow_unit.resources
			const last_viewed_resource_id = item_type === 'lesson' ? copied_item.lesson_id : copied_item.resource_id
			this.$store.commit('set', [target_array, 'PUSH', copied_item])
			this.$store.commit('set', ['last_viewed_resource_id', last_viewed_resource_id])

			// call the synch_shadow_unit_assets service to save the shadow unit mappings, then trigger to update the shadow unit
			this.$store.dispatch('synch_shadow_unit_assets', this.shadow_unit).then((result)=>{
				this.create_shadow_unit()

				// then show the message, after a brief pause
				setTimeout(x=>{
					this.$alert({
						text: msg,
						dialogMaxWidth: 500,
					}).then(y => {
					})
				}, 250)
			})
		},

		create_activity_from_resource(args) {
			// go to assignments mode, then create the activity
			this.unit_mode = 'assignments'
			setTimeout(x=>this.$refs.directives.create_new_activity(args.type, args.starting_resource, args.link_description, args.existing_activity_id))
		},

		share_my_content() {
			
		},
		
		subscribe_to_my_content() {

		},

		async publish_all_unpublished() {
			let payload = {
				user_id: this.user_info.user_id,
				level: 'unit',
				id: this.unit.lp_unit_id
			}

			if (this.site_config.new_indicator?.enabled) {
				let default_date = U.calculate_new_until_date(this.site_config.new_indicator)
				await this.$prompt({
					title: 'Set "New" Indicator?',
					text: 'Newly published assets can be marked as "New" until a set date. Enter a date below, or cancel to publish without the indicator.',
					promptType: 'text',
					type: 'date',
					initialValue: default_date,
					acceptText: 'Set and Publish',
					cancelText: 'Publish Without',
				}).then(date => {
					if (date) payload.new_until_date = date
				}).catch(() => { /* publish without indicator */ })
			}

			U.loading_start()
			await U.ajax('publish_all_assets', payload, result => {
				U.loading_stop()
				this.$inform({text: result.count + ' assets published. Reloading...'})
				setTimeout(() => { window.location.reload() }, 1000)
			})
		},

		unpublish_all() {
			this.show_unpublish_all_dialog = true
		},
		
		edit_item_saved(args) {
			// args will include `type` and `updated_resource` or `updated_lesson`

			if (args.type == 'resource' || args.type == 'activity') {
				// sparkl activities are saved as resources
				let updated_resource = new Resource(args.updated_resource)

				// call update_content_item mutation to make sure the item's changes are reflected everywhere
				this.$store.commit('update_content_item', updated_resource)

				// we also have to update the lesson in this.unit.lessons, because when we're in the unit editor, we're working from a copy of the unit
				let index = this.unit.resources.findIndex(x=>x.resource_id == updated_resource.resource_id)
				if (index != -1) {
					this.unit.resources.splice(index, 1, updated_resource)
				}

				// the user may have just changed a sparkl resource that has an associated “activity” record; if so, save the activity record if needed
				let a = this.$store.state.my_activities.find(x=>x.resource_id == updated_resource.resource_id)
				if (a) {
					let changed = false
					if (a.activity_title != updated_resource.description) {
						a.activity_title = updated_resource.description
						changed = true
					}
					if (a.activity_description != updated_resource.long_description) {
						a.activity_description = updated_resource.long_description
						changed = true
					}
					if (changed) {
						console.warn('saving updated activity')
						let payload = {
							activity_class: 'teacher',
							activity_data: a.copy_for_save(),
						}
						this.$store.dispatch('save_activity', payload).then((result)=>{
							// recreate the activity from returned data, and update via add_to_my_activities
							let new_activity = new Activity(result.activity)
							this.$store.commit('add_to_my_activities', new_activity)
						})
					}
				}

			} else if (args.type == 'lesson') {
				// this will be called by ResourceCollectionItem for editing an existing lesson, or by ResourceSearch for making an additional change to an already-saved new lesson. Note the difference here between lessons and resources: once you create a new resource via ResourceSearch, the resource editor is immediately closed; whereas a newly-created lesson can be edited even after it's saved
				let updated_lesson = args.updated_lesson

				// apply *_showing values from edited_lesson if we have it
				if (args.edited_lesson) {
					updated_lesson.resources_showing = args.edited_lesson.resources_showing
					updated_lesson.standards_showing = args.edited_lesson.standards_showing
					updated_lesson.student_description_showing = args.edited_lesson.student_description_showing
					for (let i = 0; i < args.edited_lesson.lesson_plan.length; ++i) {
						updated_lesson.lesson_plan[i].lc_showing = args.edited_lesson.lesson_plan[i].lc_showing
						updated_lesson.lesson_plan[i].lc_open_for_editing = args.edited_lesson.lesson_plan[i].lc_open_for_editing
					}
				}

				// call update_content_item mutation to make sure the item's changes are reflected everywhere
				let l = new Lesson(updated_lesson)
				this.$store.commit('update_content_item', l)

				// we also have to update the lesson in this.unit.lessons, because when we're in the unit editor, we're working from a copy of the unit
				let index = this.unit.lessons.findIndex(x=>x.lesson_id == updated_lesson.lesson_id)
				if (index != -1) {
					this.unit.lessons.splice(index, 1, l)
				}
			}
		},

		open_unit_plan_link(link) {
			this.collection.open_plan_link(link, this.unit)
		},
	}
}
</script>

<style lang="scss">
.k-collections-unit-content-wrapper {
	flex:1 1 auto;
	border-radius:0 12px 12px 0;
	background-color:#fff;
}

.k-collections-unit-content-wrapper-single-unit {
	border-radius:12px;
}

.k-collection-unit-description-outer {
	max-width:820px;
	border-radius:10px;
	margin:8px auto 12px auto;
	border:1px solid #ccc;
	background-color:#f8f8f8;

	.fr-view table td, .fr-view table th { 
		padding:4px;
		border:0;
	}
}

.k-collection-unit-description {
	font-size:14px;
	line-height:18px;
	padding:12px 8px 8px 8px;
}

.k-collection-unit-description-inner {
	// PW 4/18/2024: we used to set overflow to hidden, but sometimes wierd things can happen that cause the bottoms of descriptions to become unviewable; overflow:auto means at worst you'll have to scroll to see the full description
	// overflow:hidden;
	overflow:auto;
	transition:height 0.25s;
}

.k-collection-unit-wrapper-outer {
	max-width:1000px;
	min-height:150px;

	.k-collection-unit-wrapper {
		font-size:16px;
		padding-bottom:8px;

		// PW 5/3/2026: add some padding for accessibility outlines
		padding-left:4px;
		padding-right:4px;

		width:100%;
		// margin:8px;
		background-color:#fff;
		// border-radius:10px;
		overflow-x:hidden;
		overflow-y:auto;

		.k-collection-unit-section-header {
			font-weight:bold;
			background-color:$v-blue-darken-2;
			border-radius:5px;
			padding:2px 8px;
			color:#fff;
			font-size:20px;
		}
	}
}


.k-collection-unit-resources {
	.k-resource-link {
		background-color:$v-amber-accent-2;		// #fbe4d4
		border-radius:8px;
		padding:6px 2px 6px 2px;
		position:static;
		min-height:0;
		white-space: normal;
		height:100%;
		text-align:center;

		// flex:1 0 300px;

		.k-resource-link-inner {
			display:flex;
			align-items: center;
			min-height:30px;
			position:relative;
		}

		a {
			color:#000!important;	// #b48a6b
			display:flex;
			align-items: flex-start;
			// padding-top:6px;
		}
		a span:hover {
			text-decoration:underline;
		}
		.k-resource-description-text {
			flex:1 1 auto;
		}
		.v-icon.k-resource-type-icon { color:#000!important; margin-right:4px; }
		.k-resource-link-options-menu-btn {
			// margin-top:-4px;
			color:#000!important;
		}

		.k-resource-link-description {
			flex:1 1 100%;
			margin-left:5px;
			margin-top:0;
			word-break: break-word;
			line-height:16px;
			text-align:left;
		}
	}

	.k-resource-link-small {
		padding: 6px 4px 2px 3px;
		border-radius:6px;
		.k-resource-link-inner {
			min-height:10px;
		}
	}

	.k-resource-link--assessment {
		background-color:$v-pink-accent-4;
		a, .v-icon.k-resource-type-icon, .k-resource-link-options-menu-btn { color:#fff!important; }
	}

	.k-resource-link--teacher-facing {
		background-color:$v-blue-darken-3;
		a, .v-icon.k-resource-type-icon, .k-resource-link-options-menu-btn { color:#fff!important; }
	}

	.k-resource-link--adv {
		background-color:$v-purple-darken-4;
		a, .v-icon.k-resource-type-icon, .k-resource-link-options-menu-btn { color:#fff!important; }
	}

	.k-resource-link--stem {
		background-color:$v-lime-darken-4;
		a, .v-icon.k-resource-type-icon, .k-resource-link-options-menu-btn { color:#fff!important; }
	}

	.k-resource-link--leader-resource {
		background-color:$v-brown-darken-3;
		a, .v-icon.k-resource-type-icon, .k-resource-link-options-menu-btn { color:#fff!important; }
	}

	.k-resource-link--ese {
		background-color:$v-teal-darken-4;
		a, .v-icon.k-resource-type-icon, .k-resource-link-options-menu-btn { color:#fff!important; }
	}

	.k-resource-link--not-district-sanctioned {
		background-color:$v-red-darken-4;
		a, .v-icon.k-resource-type-icon, .k-resource-link-options-menu-btn { color:#fff!important; }
	}

	.k-resource-link--unit-planning-guide {
		background-color:$v-green-darken-4;
		a, .v-icon.k-resource-type-icon, .k-resource-link-options-menu-btn { color:#fff!important; }
	}

	.k-resource-link--course-guidance {
		background-color:$v-cyan-darken-3;
		a, .v-icon.k-resource-type-icon, .k-resource-link-options-menu-btn { color:#fff!important; }
	}

	.k-resource-link-check-box {
		color:$v-pink-accent-1!important;
	}

	// .k-resource-link--search_match {
	// 	background-color:$v-yellow-lighten-3!important;
	// 	border:2px solid $v-yellow-darken-1!important;
	// 	padding:2px 6px 2px 4px;
	// }
}

.k-instance-unit-autocomplete {
	.v-select__selections { flex-wrap:nowrap!important; white-space:nowrap;}
}

.k-collection-unit-plan-banner {
	text-align:center;
	background-color:#eee;
	padding:6px 0px;
	border-radius:4px;
}

.k-collection-unit-plan-section-header {
	margin:12px 0 8px 0;
	padding:6px 8px;
	border-radius:4px;
	font-weight:900;
	font-size:18px;
	color:#fff;
	.v-icon {
		font-size:18px;
		color:#fff;
	}
}

.k-collection-unit-plan-section-content {

}

.k-unit-plan-links {
	display:flex;
	justify-content: center;
	align-items: center;
	border-radius:8px;
}

.k-unit-plan-link-outer {
	border-radius:8px;
	padding:8px 4px 4px 4px;
	// margin:0 -1px 0 0;
	margin:0 2px;
	box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
	border:1px solid #ccc;
	background-color:#f8f8f8;
	min-width:124px;
	cursor:pointer;
}
.k-unit-plan-link-outer:hover {
	background-color:#eee;
	border-color:#666;
}

.k-unit-plan-link-icon-outer {
	text-align:center;
	.v-icon {
		font-size:32px;
	}
}

.k-unit-plan-link {
	display:block;
	font-weight:900;
	font-size:12px;
	margin-top:4px;
	text-align:center;
	color:#000;
}


</style>
